import { myInput } from '../input.js';
import { utils } from '../utils.js';
import { myToolbar } from '../tools/toolbar.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';

export const cameras = {};

// called when changing window size or exiting menu

cameras.resize = () => {

    b3.ee.emit('resize');

    // call resize function on resizable elements
    [
        beads,
    ].forEach(element => {
        if (!element?.resize) return;
        element.resize();
    });

    // change size of game canvas
    game.cameras.resize(game.scale.width, game.scale.height);
};

cameras.initialize = () => {
    game.cameras.main
        .setBackgroundColor(settings.theme.backgroundColor)
        .setScroll(500, 400);
    cameras.top = game.cameras.add(0, 0, game.scale.width, game.scale.height);
    cameras.currentZoom = 4;
    cameras.currentlyPanning = false;
};

cameras.getWorldBounds = () => {
    const result = {
        maxY: null, maxX: null,
    };

    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        result.maxY = Math.max(bead.y, result.maxY);
        result.maxX = Math.max(bead.x, result.maxX);
    });

    return result;
};

cameras.newProject = myConfig => {

    let config = myConfig.camera;

    if (config == null) {
        config = {
            scroll: settings.pattern.startScroll || [150, 150],
            zoom:0.6,
            angle: (Math.PI / 2)
        };
    }

    cameras.worldBounds = cameras.getWorldBounds();

    game.cameras.main.setScroll(config.scroll[0],config.scroll[1]);
    game.cameras.main.setZoom(config.zoom);


    const myAngle = settings.pattern.rotateCamera ?
        config.angle:
        config.angle - (Math.PI / 2)

    game.cameras.main.setRotation(myAngle);

    myToolbar.enableTool('Zoom In');
    myToolbar.enableTool('Zoom Out');
    if (game.cameras.main.zoom < 0.10095) {
        myToolbar.disableTool('Zoom Out');
    }
    if (game.cameras.main.zoom > 2.28) {
        myToolbar.disableTool('Zoom In');
    }
};

cameras.zoomOut = (amount=1.05) => {
    if (game.cameras.main.zoom >= 0.10095) {
        game.cameras.main.zoom /= amount;
        myToolbar.enableTool('Zoom In');
    }
    if (game.cameras.main.zoom < 0.10095) {
        game.cameras.main.zoom = 0.10095
        myToolbar.disableTool('Zoom Out');
    }
};

cameras.zoomIn = (amount=1.05) => {
    if (game.cameras.main.zoom <= 2.28) {
        game.cameras.main.zoom *= amount;
        myToolbar.enableTool('Zoom Out');
    }
    if (game.cameras.main.zoom > 2.28) {
        game.cameras.main.zoom = 2.28
        myToolbar.disableTool('Zoom In');
    }
};

cameras.zoom = depth => {
    game.cameras.main.setZoom(depth);
};

cameras.startPan = () => {
    cameras.currentlyPanning = true;
    game.clickPoint = utils.oldReturnPoint(
        game.input.activePointer.position.x,
        game.input.activePointer.position.y
    );
    game.startScroll = {
        x: game.cameras.main.scrollX,
        y: game.cameras.main.scrollY
    };
};

cameras.pan = () => {
    const userIsPanning = game.input.activePointer.isDown && myInput.pointerEnabled;

    if (!userIsPanning) {
        cameras.currentlyPanning = false;
        return;
    }
    if (!cameras.currentlyPanning) cameras.startPan();
    if (!game.clickPoint) return;

    const myPoint = utils.oldReturnPoint(
        game.input.activePointer.position.x,
        game.input.activePointer.position.y, true
    );

    if (settings.pattern.rotateCamera) {
        game.cameras.main.scrollX = game.startScroll.x + (game.clickPoint.y - myPoint.y);
        game.cameras.main.scrollY = game.startScroll.y - (game.clickPoint.x - myPoint.x);
    } else {
        game.cameras.main.scrollX = game.startScroll.x + (game.clickPoint.x - myPoint.x);
        game.cameras.main.scrollY = game.startScroll.y + (game.clickPoint.y - myPoint.y);
    }
};

// pinch

// https://developer.mozilla.org/en-US/docs/Web/API/Pointer_events/Pinch_zoom_gestures

b3.evCache = [];
b3.prevDiff = -1;

cameras.initializePinch = () => {
    const el = document.querySelector('#phaser-div canvas');
    el.onpointerdown = pointerdownHandler;
    el.onpointermove = pointermoveHandler;
    el.onpointerup = pointerupHandler;
    el.onpointercancel = pointerupHandler;
    el.onpointerout = pointerupHandler;
    el.onpointerleave = pointerupHandler;
};

function pointerdownHandler(ev) {
    b3.evCache.push(ev);
}

function pointermoveHandler(ev) {
    const index = b3.evCache.findIndex(cachedEv => cachedEv.pointerId === ev.pointerId);
    b3.evCache[index] = ev;

    if (b3.evCache.length !== 2) return;

    const curDiff = Math.abs(b3.evCache[0].clientX - b3.evCache[1].clientX);

    if (b3.prevDiff > 0) {
        if (curDiff > b3.prevDiff) {
            cameras.zoomIn(1.01);
        }
        if (curDiff < b3.prevDiff) {
            cameras.zoomOut(1.01);
        }
    }

    b3.prevDiff = curDiff;
}

function pointerupHandler(ev) {
    const index = b3.evCache.findIndex(cachedEv => cachedEv.pointerId === ev.pointerId);
    b3.evCache.splice(index, 1);
    if (b3.evCache.length < 2) b3.prevDiff = -1;
}

